export default {
	EXPRESSION: 'EXPRESSION',
	FIELD: 'FIELD',
	VALUE: 'VALUE',
	SCRIPT: 'SCRIPT',
	VALUE_FORM_SUBMIT: 'VALUE_FORM_SUBMIT'
};
